export class SlmTransactionType {
  code?: string;
  name?: string;
  label?: string;
}
